import { Component, OnInit } from '@angular/core'
import { STORAGE_USER_LOGIN } from 'src/app/app-settings'
import { LoginService } from '../services/login.service'
import { HttpErrorResponse } from '@angular/common/http'
import { InputInfo } from 'src/app/shared/components/ag-input-field/ag-input-field.component'
import { ToastServiceV2 } from 'src/app/shared/services/toast-v2/toast-v2.service'
import { IconImageService } from 'src/app/shared/services/icon-image.service'

@Component({
    selector: 'app-agent-new-password',
    templateUrl: './agent-new-password.component.html',
    styleUrls: ['./agent-new-password.component.scss'],
    standalone: false
})
export class AgentNewPasswordComponent implements OnInit {
  oldPasswordInfo: InputInfo = { showInfo: false, type: 'info', text: 'Info' }
  newPasswordInfo: InputInfo = { showInfo: false, type: 'info', text: 'Info' }
  confirmNewPasswordInfo: InputInfo = { showInfo: false, type: 'info', text: 'Info' }
  email: string = localStorage.getItem(STORAGE_USER_LOGIN) || ''
  oldPassword: string = ''
  newPassword: string = ''
  confirmNewPassword: string = ''

  constructor(
    private loginService: LoginService,
    private toaster: ToastServiceV2,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {}

  changeOld(event: string) {
    this.oldPassword = event
  }
  changeNew(event: string) {
    this.newPassword = event
  }
  changeConfirm(event: string) {
    this.confirmNewPassword = event
    if (this.confirmNewPassword !== this.newPassword) {
      this.confirmNewPasswordInfo = { showInfo: true, type: 'error', text: 'Passwords do not match' }
      this.newPasswordInfo = { showInfo: true, type: 'error', text: 'Passwords do not match' }
    } else {
      this.confirmNewPasswordInfo = { showInfo: false, type: 'info', text: 'Info' }
      this.newPasswordInfo = { showInfo: false, type: 'info', text: 'Info' }
    }
  }

  canSave(): boolean {
    if (this.oldPassword.length === 0) return false
    if (this.newPassword.length === 0) return false
    if (this.confirmNewPassword.length === 0) return false
    if (this.newPassword !== this.confirmNewPassword) return false
    else return true
  }

  changePassWord() {
    if (!this.newPassword || !this.confirmNewPassword || !this.oldPassword) {
      this.confirmNewPasswordInfo = { showInfo: true, type: 'error', text: 'Please fill all fields' }
      this.newPasswordInfo = { showInfo: true, type: 'error', text: 'Please fill all fields' }
      this.oldPasswordInfo = { showInfo: true, type: 'error', text: 'Please fill all fields' }
      return
    }
    if (this.newPassword !== this.confirmNewPassword) {
      this.confirmNewPasswordInfo = { showInfo: true, type: 'error', text: 'Passwords do not match' }
      this.newPasswordInfo = { showInfo: true, type: 'error', text: 'Passwords do not match' }
      return
    } else {
      this.loginService.newPassword(this.email, this.oldPassword, this.newPassword).subscribe(
        (res) => {
          this.oldPasswordInfo = { showInfo: false, type: 'info', text: 'Info' }
          this.newPasswordInfo = { showInfo: false, type: 'info', text: 'Info' }
          this.confirmNewPasswordInfo = { showInfo: false, type: 'info', text: 'Info' }
          this.toaster.success({ title: 'Password changed successfully' })
          window.location.href = '/main/general'
        },
        (err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.oldPasswordInfo = { showInfo: true, type: 'error', text: 'Old password is incorrect' }
            }
          }
        },
      )
    }
  }
}
